import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { getCarriersPath } from '../../../../../routes/constants';
import ConfigureNotAllowedWarning from './wrapper';
import messages from '../../messages';
import styles from '../editor/styles.module.less';

const ModalWarning = () => {
  return (
    <div className={styles['warning-wrapper']}>
      <ConfigureNotAllowedWarning>
        <p>
          <FormattedMessage
            {...messages.configureNotAllowedModal}
            values={{
              bold: (chunks) => <span>{chunks}</span>,
              carriersLink: (chunks) => <Link to={getCarriersPath()}>{chunks}</Link>,
            }}
          />
        </p>
      </ConfigureNotAllowedWarning>
    </div>
  );
};

export default ModalWarning;
